import { render, staticRenderFns } from "./p14.vue?vue&type=template&id=012b673f&scoped=true&"
import script from "./p14.vue?vue&type=script&lang=js&"
export * from "./p14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b673f",
  null
  
)

export default component.exports